const ROOT = 'dashboard/commercial';

export default {
	arrayList: `${ROOT}/list`,
	status: `${ROOT}/status/`,
};
